<template>
    <select 
        name="user" 
        :value="formattedValue" 
        id="user" 
        class="form-control" 
        @input="$emit('input', $event.target.value)"
        :disabled="loading || $attrs.disabled"
        v-bind="$attrs"
    >
        <option
            :value="null"
            v-if="loading"
        >
            Loading...
        </option>
        <option 
            :value="null"
            :selected="formattedValue == null"
        >
            Select a user...
        </option>
        <option
            v-if="enableNull"
            :value="0"
        >
            No user
        </option>
        <option 
            v-for="user in filteredUsers" 
            :key="user.id" 
            :value="user.id"
            :selected="user.id === formattedValue"
        >
            {{ user.name }}
        </option>
    </select>
</template>

<script>
import AuthService from "../services/AuthService";
import { mapActions, mapState } from 'vuex';

export default {
    props: {
        value: {
            type: [Number, String],
            default: null,
        },

        options: {
            type: Array,
            default: null,
            required: false,
        },

        engineers: {
            type: Boolean,
            default: true,
        },

        office: {
            type: Boolean,
            default: true,
        },

        admins: {
            type: Boolean,
            default: true,
        },

        autoselect: {
            type: Boolean,
            default: true,
        },

        enableNull: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        ...mapState('users', [
            'users',
            'loading'
        ]),
        currentUser() {
            return AuthService.user;
        },

        filteredUsers() {
            // If current user is just an engineer don't allow them to select other users
            if (!this.currentUser.office_access && !this.currentUser.admin_access && !this.office && !this.admins) {
                return [this.currentUser];
            }
            return this.users.filter(user => {
                if (this.engineers && user.engineer_access) {
                    return user;
                }

                if (this.office && user.office_access) {
                    return user;
                }

                if (this.admins && user.admin_access) {
                    return user;
                }

                return false;
            });
        },
        formattedValue() {
            if (this.value === undefined || this.value === null) {
                return null;
            }
            if (typeof this.value === 'string') {
                return parseInt(this.value);
            }

            return this.value;
        },
    },

    watch: {
        value() {
            this.checkAutoselect();
            this.$forceUpdate();
        },
        users: {
            immediate: true,
            handler() {
                this.checkAutoselect();
            }
        }
    },

    mounted() {
        if(!this.users.length) {
            this.loadUsers();
        }
    },

    methods: {
        ...mapActions('users', ['loadUsers']),

        checkAutoselect() {
            if (this.value === null && this.autoselect) {
                const user_id = this.currentUser.id;
                if (this.filteredUsers.find(user => user.id === user_id)) {
                    this.$emit('input', `${user_id}`);
                }
            }
        },
    },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/UserSelectComponent.vue